import { useSelector } from 'react-redux';
import { useGetUserRoleQuery } from 'src/graphql';
import {
  selectProfilePicture,
  selectUsername,
  selectUserRole,
} from 'src/redux/auth/auth.selectors';
import { setUserRole } from 'src/redux/auth/auth.slice';
import { selectActiveConfigurationUuid } from 'src/redux/configuration/configuration.selectors';
import { useAppDispatch } from 'src/redux/store';
import { EUserRoles } from 'src/typings/base-types';

export type TUseAuth = {
  isMember: boolean;
  isAdmin: boolean;
  isManager: boolean;
  userRole?: EUserRoles;
  profilePicture: string;
  userName: string;
  isLoadingGetUserRole: boolean;
};

export const useAuth = (): TUseAuth => {
  const dispatch = useAppDispatch();

  const userRole = useSelector(selectUserRole);
  const profilePicture = useSelector(selectProfilePicture);
  const userName = useSelector(selectUsername);
  const configUuid = useSelector(selectActiveConfigurationUuid);

  const {
      loading: isLoadingGetUserRole,
    } = useGetUserRoleQuery({
      fetchPolicy: 'cache-first',
      skip: !configUuid,
      variables: { configUuid: configUuid! },
      onCompleted: (data) => {
        if (!!data?.isUserCommunityManager) {
          dispatch(setUserRole(EUserRoles.ExchangeOperator));
        } else {
          dispatch(setUserRole(EUserRoles.Researcher));
        }
      },
    });

  const isMember = userRole === EUserRoles.Researcher;
  const isManager = userRole === EUserRoles.ExchangeOperator;
  const isAdmin = userRole === EUserRoles.Admin || userRole === EUserRoles.ExchangeOperator;

  return { isMember, isAdmin, isManager, userRole, profilePicture, userName, isLoadingGetUserRole };
};
